// Generated file : do not modify
export enum BrancheTypes
{
  NONE = 0,
  PES,
  CONTROL
};

import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Branches d'activité
export default class Branche  {
  // Identifiant unique
  public id: number;
  // Catégorie
  public type: BrancheTypes;
  // code
  public code: string;
  // Libellé
  public nom: string;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.type = BrancheTypes.NONE;
    this.code = '';
    this.nom = '';
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Branche): Branche {
    const newBranche: Branche = new Branche();
    newBranche.id = obj.id;
    newBranche.type = obj.type;
    newBranche.code = obj.code;
    newBranche.nom = obj.nom;
    newBranche.canUpdate = obj.canUpdate;
    newBranche.canDelete = obj.canDelete;
    newBranche.display = obj.display;
    newBranche.notifDefType = obj.notifDefType;
    return newBranche;
  }

  public toJsonBranche (): string {
    const json = {
      type: this.type,
      code: this.code,
      nom: this.nom,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromBranche (obj: Branche): void {
    this.id = obj.id;
    this.type = obj.type;
    this.code = obj.code;
    this.nom = obj.nom;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareBranche (value: Branche): boolean {
    return (this.toJsonBranche() == value.toJsonBranche());
  }

  public cloneBranche (): Branche {
    return Branche.fromJson(this);
  }

  public create (): Promise<Branche> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/branches/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromBranche(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public update (): Promise<Branche> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/branches/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromBranche(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public delete (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/branches/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/branches/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Branche> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Branches/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Branche.fromJson(listData.reccords[0] as Branche);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(branches: Branche[]) {
  }
}
